var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.706 11.9998L0 11.2938L4.9405 6.3533C5.03424 6.25954 5.08689 6.13238 5.08689 5.9998C5.08689 5.86722 5.03424 5.74006 4.9405 5.6463L0.0085001 0.715301L0.7155 0.00830078L5.6465 4.9393C5.92771 5.22059 6.08568 5.60205 6.08568 5.9998C6.08568 6.39755 5.92771 6.77901 5.6465 7.0603L0.706 11.9998Z",
    fill: "#FF5151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallChevron);
export default __webpack_public_path__ + "static/media/small-chevron.7a186c587004fbfd9c2df5dc034248bc.svg";
export { ForwardRef as ReactComponent };